import { ReglamentBtn } from './ReglamentBtn';

export default ReglamentBtn;
